import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RefiOptimizer from "@/pages/RefiOptimizer";

export const Route = createFileRoute("/refi-optimizer")({
  head: () => seoHead("/refi-optimizer"),
  component: RefiOptimizer,
});
